import React from 'react';
import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    EmailShareButton,
    EmailIcon,
    WhatsappShareButton,
    WhatsappIcon
  } from 'react-share';

class ShareDialog extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div id={`modal-${this.props.buttonId}`} class="modal fade" tabindex="-1" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="t-center modal-title gipsiero-red">Share Now!</h4>
                        </div>
                        <div class="modal-body">
                            <div id="socialShareButtonsWrapper">  
                                <FacebookShareButton 
                                    url={this.props.shareUrl} 
                                    /*quote={props.facebook.quote}*/ 
                                    hashTag={ this.props.facebook.hashTag}>
                                    <div class="socialShareButtonContent">
                                        <div class="shareIcon">
                                            <FacebookIcon size={32} round={true} /> 
                                        </div>
                                        <div>
                                            Share
                                        </div>
                                    </div>
                                </FacebookShareButton>
                                <TwitterShareButton 
                                    url={this.props.shareUrl} 
                                    title={this.props.twitter.title} 
                                    via={ this.props.twitter.via} 
                                    hashTags={ this.props.twitter.hashTags}>
                                    <div class="socialShareButtonContent">
                                        <div class="shareIcon">
                                            <TwitterIcon size={32} round={true} />
                                        </div>
                                        <div>
                                            Tweet
                                        </div>
                                    </div>
                                </TwitterShareButton>
                                <EmailShareButton 
                                    url={ this.props.shareUrl} 
                                    subject={ this.props.email.subject} 
                                    body={ this.props.email.body}>
                                    <div class="socialShareButtonContent">
                                        <div class="shareIcon">
                                            <EmailIcon size={32} round={true} />
                                        </div>
                                        <div>
                                            Email
                                        </div>
                                    </div>
                                </EmailShareButton>
                                <WhatsappShareButton
                                    url={ this.props.shareUrl} 
                                    title={this.props.twitter.title} 
                                >
                                    <div class="socialShareButtonContent">
                                        <div class="shareIcon">
                                            <WhatsappIcon size={32} round={true} />
                                        </div>
                                        <div>
                                            WhatsApp
                                        </div>
                                    </div>
                                </WhatsappShareButton>
                            </div>                        
                    </div>
                        <div class="modal-footer">
                            <button type="button" class="button button-green share-modal-close" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default ShareDialog;